export default "__VITE_ASSET__8aPcGVmd__"